import { useState } from 'react';

import type { UploadDocumentTarget } from '#api-bridge/documentApi.ts';
import type { Document, DocumentAssociation, Documents } from '#domain/Document.ts';

import { DocumentDialog } from './DocumentDialog.tsx';
import { DocumentsCategory } from './Documents.tsx';
import { DocumentUploadDialog } from './DocumentUploadDialog.tsx';
import { useStopsPollingWhileMounted } from './documentPolling.context.tsx';

type DocumentsProps = {
    label?: string;
    documents?: Documents;
    upload?: {
        target: UploadDocumentTarget;
        associations: DocumentAssociation[];
        buttonTitle?: string;
    };
};

export const DocumentGroup = ({ label, documents, upload }: DocumentsProps) => {
    const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    useStopsPollingWhileMounted(selectedDoc !== null);

    const uploadDocument = () => setShowUploadDialog(true);

    return (
        <>
            <DocumentDialog
                doc={selectedDoc}
                onClose={() => {
                    setSelectedDoc(null);
                }}
            />
            {upload && (
                <DocumentUploadDialog
                    shown={showUploadDialog}
                    onClose={() => setShowUploadDialog(false)}
                    associations={upload.associations}
                    uploadTarget={upload.target}
                />
            )}
            <DocumentsCategory
                label={label}
                onDocPress={value => {
                    setSelectedDoc(value);
                }}
                uploadDocument={upload ? uploadDocument : undefined}
                uploadButtonTrackingKey='ordercom.documents.group.upload'
                documents={documents}
                buttonTitle={upload?.buttonTitle}
            />
        </>
    );
};
